import React, { useEffect, useState } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __, getActiveStage } from '../../core/utils';
import Button from '../../components/Button';
import Tags from '../../components/Tags';
import { readStage } from '../../redux/actions/table/stages';
import { listPossibleTags } from '../../redux/actions/general';
import styles from '../../styles/forms/wizard_multiple_task_tags_edit/MultipleTaskTagsEditForm.scss';

const MultipleFileTagsEditForm = ({
  handleSubmit,
  onClose,
  submitting,
}) => {
  const [stageTags, setStageTags] = useState([]);

  useEffect(() => {
    readStage(getActiveStage()).then(({ response }) => {
      listPossibleTags('project', response.data.project_id).then(
        ({ response }) => {
          setStageTags(response.data);
        },
      );
    });
  }, []);

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <span className={styles.desc}>
        {__(
          'files.multiple-actions.multiple-tag-edit-wizard.description.action-will-add-additional-tags',
          {},
          'This action will add additional tags to selected files.',
        )}
      </span>
      <Field
        name='tags'
        component={Tags}
        label={__('Tags')}
        options={stageTags}
      />
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <Button
          lightBlue
          medium
          submit
          right
          middleText={__('Save')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'wizard_multiple_file_tags_edit.multiple_file_tags_edit',
})(MultipleFileTagsEditForm);
